import React, { useState, useEffect } from "react";
import { BrowserProvider, Contract } from "ethers";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import BottomBar from "../Components/BottomBar";
import {getActiveElection} from "../services/ElectionService";

const CONTRACT_ADDRESS = process.env.REACT_APP_CONTRACT_ADDRESS;
let CONTRACT_ABI = [];
try {
    CONTRACT_ABI = JSON.parse(process.env.REACT_APP_CONTRACT_ABI || [{"inputs":[{"internalType":"string","name":"_empId","type":"string"}],"name":"vote","outputs":[],"stateMutability":"nonpayable","type":"function"}]
    );
} catch (e) {
    console.error("Invalid ABI in environment:", e);
}

const BallotSheetPage = () => {
    const [selectedCandidate, setSelectedCandidate] = useState(null);
    const [candidates, setCandidates] = useState([]);
    const [contract, setContract] = useState(null);
    const [account, setAccount] = useState(null);
    const [totalVotes, setTotalVotes] = useState(0);
    const [noActiveElection, setNoActiveElection] = useState(false);
    const navigate = useNavigate();
    const [election, setElection] = useState(null);

    useEffect(() => {
        loadBlockchainData();
        loadActiveElectionCandidates();
    }, []);

    const loadBlockchainData = async () => {
        if (window.ethereum) {
            try {
                await window.ethereum.request({ method: "eth_requestAccounts" });
                const provider = new BrowserProvider(window.ethereum);
                const signer = await provider.getSigner();
                const address = await signer.getAddress();
                setAccount(address);
                const votingContract = new Contract(CONTRACT_ADDRESS, CONTRACT_ABI, signer);
                setContract(votingContract);
            } catch (error) {
                console.error("Error connecting to MetaMask:", error);
                alert("Failed to connect to MetaMask.");
            }
        } else {
            alert("Please install MetaMask.");
        }
    };

    const loadActiveElectionCandidates = async () => {
        try {
            const activeElectionRes = await axios.get("https://blockballot-production.up.railway.app/elections/active", {
                validateStatus: () => true,
            });
            if (activeElectionRes.status === 204) {
                setNoActiveElection(true);
                setCandidates([]);
                return;
            }
            const activeElection = activeElectionRes.data;
            setElection(activeElection);
            const { data: rawCandidates } = await axios.get(
                `https://blockballot-production.up.railway.app/api/election/${activeElection.id}/candidates`
            );
            setCandidates(rawCandidates);
            setTotalVotes(rawCandidates.reduce((acc, c) => acc + (c.voteCount || 0), 0));
        } catch (error) {
            console.error("Error loading active election or candidates:", error);
        }
    };

    const handleSelect = (id) => {
        setSelectedCandidate(selectedCandidate === id ? null : id);
    };

    const handleVote = async () => {
        if (!contract || !selectedCandidate) {
            alert("Select a candidate and ensure MetaMask is connected.");
            return;
        }
        try {
            const transaction = await contract.vote(selectedCandidate);
            await transaction.wait();
            alert(`Voted for candidate ID: ${selectedCandidate}`);
            setSelectedCandidate(null);
            setTimeout(() => {
                navigate("/QRScanPage");
            }, 3000);
        } catch (error) {
            console.error("Voting failed:", error);
            alert("Transaction failed.");
        }
    };

    return (
        <div className="min-h-screen bg-black text-white flex flex-col">
            <div className="bg-white text-black py-6">
                {/*<h1 className="text-center text-2xl font-bold">COMPANY NAME</h1>*/}
                <p className="text-center text-lg mt-2">{noActiveElection ? "" : election ? election.name : "Loading Election..."}</p>
            </div>
            <div className="flex-1 overflow-y-auto px-4 py-6">
                <div className="max-w-2xl mx-auto space-y-4">
                    <p className="text-center text-lg mt-2">{noActiveElection ? "No elections in progress" : election ? "": ""}</p>
                    {candidates.map((candidate) => (
                        <div
                            key={candidate.empId}
                            className={`flex items-center justify-between bg-white text-black p-4 rounded-lg ${
                                selectedCandidate === candidate.empId ? "ring-2 ring-black" : ""
                            }`}
                        >
                            <div className="flex items-center space-x-3">
                                <div className="bg-gray-700 w-10 h-10 flex items-center justify-center rounded-full">
                                    <span className="text-xl text-white">👤</span>
                                </div>
                                <div>
                                    <p className="font-medium">{candidate.nameOfCandidate}</p>
                                    <p className="text-sm text-gray-500">{candidate.currentDesignation}</p>
                                </div>
                            </div>
                            <button
                                className={`w-8 h-8 flex items-center justify-center rounded-full border ${
                                    selectedCandidate === candidate.empId
                                        ? "bg-black text-white border-black"
                                        : "border-gray-400"
                                }`}
                                onClick={() => handleSelect(candidate.empId)}
                            >
                                {selectedCandidate === candidate.empId && (
                                    <span className="text-lg font-bold">✕</span>
                                )}
                            </button>
                        </div>
                    ))}
                </div>
            </div>
            <div className="bg-black px-4 py-4 flex flex-col items-center">
                <button
                    className="w-1/12 bg-white text-black py-1 rounded-md font-semibold border border-gray-400 hover:bg-gray-200"
                    onClick={handleVote}
                >
                    Confirm Vote
                </button>
            </div>
            <div >
                <BottomBar/>
                 </div>
        </div>
    );
};

export default BallotSheetPage;
